/**
 * TEMPERATURE SERVICE — Mobile-ready business logic layer
 * Encapsula tota la lògica de control de temperatures APPCC.
 */
import hosys from "@/api/api";
import moment from "moment";

export const DEFAULT_LIMITS = {
  fridge:         { min: 0,   max: 5   },
  freezer:        { min: -25, max: -15 },
  chamber:        { min: 0,   max: 8   },
  prepared_food:  { min: 60,  max: 100 },
  fryer_oil:      { min: 160, max: 180 },
  cold_reception: { min: 0,   max: 5   },
};

export const EQUIPMENT_LABELS = {
  fridge:         "Nevera",
  freezer:        "Congelador",
  chamber:        "Cambra",
  prepared_food:  "Menjar preparat",
  fryer_oil:      "Oli fregidora",
  cold_reception: "Recepció freds",
};

export function evaluateTemperature(temperature, equipmentType, customLimits = null) {
  const limits = customLimits || DEFAULT_LIMITS[equipmentType] || { min: 0, max: 10 };
  return (temperature >= limits.min && temperature <= limits.max) ? "correct" : "incorrect";
}

export async function recordTemperature(venueId, user, data, selectedDate) {
  const limits = {
    min: data.min_limit ?? DEFAULT_LIMITS[data.equipment_type]?.min ?? 0,
    max: data.max_limit ?? DEFAULT_LIMITS[data.equipment_type]?.max ?? 10,
  };
  const status = evaluateTemperature(data.temperature, data.equipment_type,
    data.min_limit != null ? limits : null);

  const record = await hosys.entities.TemperatureRecord.create({
    venue_id: venueId,
    equipment_name: data.equipment_name,
    equipment_type: data.equipment_type,
    temperature: data.temperature,
    min_limit: limits.min,
    max_limit: limits.max,
    status,
    observations: data.observations || "",
    photo_url: data.photo_url || "",
    responsible_email: user.email,
    responsible_name: user.full_name,
    date: selectedDate || moment().format("YYYY-MM-DD"),
  });

  let alert = null;
  if (status === "incorrect") {
    alert = await hosys.entities.Alert.create({
      venue_id: venueId,
      type: "temperature",
      title: `Temperatura incorrecta: ${data.equipment_name}`,
      message: `S'ha registrat ${data.temperature}°C. Rang: ${limits.min}°–${limits.max}°C.`,
      severity: "danger",
      status: "active",
      reference_type: "TemperatureRecord",
      reference_id: record.id,
    });
  }

  return { record, alert };
}

export async function getTemperatureRecords(venueId, date) {
  return hosys.entities.TemperatureRecord.filter({ venue_id: venueId, date }, "-created_date");
}

export async function getDailyTemperatureSummary(venueId, date) {
  const records = await getTemperatureRecords(venueId, date);
  const correct = records.filter(r => r.status === "correct").length;
  return {
    total: records.length,
    correct,
    incorrect: records.length - correct,
    pct: records.length > 0 ? Math.round((correct / records.length) * 100) : 0,
    records,
  };
}